<template>
<div>
  <b-card>
    <div class="text-right mb-3">
      <router-link class="btn btn-primary" :to="{name:'dsr.create'}"><i class="fa fa-plus"></i> Criar</router-link>
      <exporter grid-ref="theGrid" :url="url + '/export'"></exporter>
    </div>
    <grid-filters grid-data="theGrid" :fields="gridFilters" ></grid-filters>
    <Grid ref="theGrid" name="dsrGrid" :preload="preload" v-bind:url="url" v-bind:columns="columns" :pageable='true' :filterable='true' :sortable='true' v-bind:schemaModelFields="schemaModelFields"></Grid>
  </b-card>
  <b-modal ref="downloadModal" id="downloadModal">
    O ficheiro está pronto:
    <a :href="fileDownload.url" target="_blank">{{ fileDownload.title }}</a>
    <div slot="modal-footer" class="w-100">
      <b-btn size="sm" class="float-right" variant="primary" @click="hideModal">
        Close
      </b-btn>
    </div>
  </b-modal>
</div>
</template>

<script>
import Grid from '@/components/Grid.vue'
import router from '@/router'
import lists from '@/components/States.js'

export default {
  name: 'UsersGrid',
  components: {
    Grid
  },
  data() {
    return {
      exporting: false,
      fileDownload: {
        url: '',
        title: ''
      },
      gridFilters: [{
        field:'dealer_id',
        modal:'dealers-modal',
        foreign: 'id',
        placeholder: 'Distribuidor'
      }],
      schemaModelFields: {
        'created_at': {
          type: 'date'
        },
        'dealer_id': {
          type: 'number'
        }
      },
      url: 'dsr',
      preload: [{
        api: 'dealers/lst',
        field: 'dealer_id'
      }],
      columns: [{
        template: this.getBtnTemplate,
        title: '',
        width: '180px'
      },
      {
        field: 'id',
        title: 'Id',
        width: '120px'
      },
      {
        field: 'name',
        title: 'Nome',
        width: '220px'
      },
      {
        field: 'code',
        title: 'Código',
        width: '120px'
      },
      {
        field: 'inparuser.data.username',
        title: 'Nome de utilizador',
        sortable: false,
        width: '120px'
      },
      {
        field: 'state',
        title: 'Estado',
        values: lists.dsrStates,
        width: '120px'
      },
      {
        field: 'dealer_id',
        title: 'Distribuidor',
        values:[],
        width: '180px'
      },
      {
        field: 'dsr_type',
        title: 'Tipo',
        values: lists.dsrTypes,
        width: '120px'
      },
      {
        field: 'old_id',
        title: 'ID v1',
        width: '120px'
      },
      {
        field: 'old_leader_id',
        title: 'ID CV v1',
        width: '120px'
      },
      {
        field: 'old_manager_id',
        title: 'ID Gerente v1',
        width: '120px'
      },
      {
        field: 'user_id',
        title: 'User ID',
        width: '120px'
      },
      {
        field: 'created_at',
        title: 'Criado em',
        format: '{0:dd/MM/yyyy HH:mm}',
        type: 'date',
        width: '180px',
        filterable: {
          // ui: "datetimepicker"
          ui: function(element) {
            element.kendoDateTimePicker({
              format: 'dd/MM/yyyy HH:mm'
            })
          }
        }
      }]
    }
  },
  methods: {
    hideModal: function() {
      this.$refs.downloadModal.hide()
    },
    exportGrid: function() {
      this.exporting = true
      var grid = this.$refs.theGrid.$refs.mygrid.kendoWidget()
      console.log(grid.getOptions())
      this.axios.post(this.url + '/export', {
        filter: grid.getOptions().dataSource.filter
      }).then(response => {
        this.fileDownload = response.data
        this.$refs.downloadModal.show()
        this.exporting = false
      }).catch(error => {
        this.$bvToast.toast('Houve um erro a exportar', { autoHideDelay: 5000, variant: 'danger', solid: true})
        this.exporting = false
      })
    },
    getBtnTemplate: function(item) {
      var route = router.resolve({
        name: 'dsr.edit',
        params: {
          id: item.id
        }
      })
      if (this.$auth.check('dsr.edit')) {
        return '<a href="' + route.href + '" class="btn btn-primary" ><i class="fa fa-pencil"></i> editar</a>'
      }
      return ''
    }
  }
}
</script>
